export default "__VITE_ASSET__dMEQN6NR__"